'use client'

import React, { Component } from 'react'

import { Button, Link, Typography } from '@mui/material'

// Fallback UI component
const ErrorFallback = ({ errorMessage }: { errorMessage: string }) => {
  // Vars
  const lightImg = '/images/pages/misc-mask-1-light.png'

  return (
    <div className='flex items-center justify-center min-bs-[100dvh] relative p-6 overflow-x-hidden'>
      <div className='flex items-center flex-col text-center gap-10'>
        <div className='flex flex-col gap-2 is-[90vw] sm:is-[unset]'>
          <Typography className='font-medium text-4xl' color='text.primary'>
            Terjadi kesalahan!
          </Typography>
          <Typography variant='h6'> Kami minta maaf, tetapi terjadi sesuatu yang tidak terduga.</Typography>
          <Typography sx={{ color: 'error.main' }}>
            <strong>Detail Kesalahan:</strong> {errorMessage}
          </Typography>
        </div>
        <img
          alt='error-illustration'
          src='/images/illustrations/characters/3.png'
          className='object-cover bs-[400px] md:bs-[450px] lg:bs-[500px]'
        />
        <Button href='/' component={Link} variant='contained'>
          Back to Home
        </Button>
      </div>
      <img src={lightImg} className='absolute bottom-0 z-[-1] is-full max-md:hidden' />
    </div>
  )
}

// ErrorBoundary component
class ErrorBoundary extends Component<{ children: React.ReactNode }, { hasError: boolean; errorMessage: string }> {
  constructor(props: any) {
    super(props)
    this.state = { hasError: false, errorMessage: '' }
  }

  // Static method for error handling
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorMessage: error.message } // Update state to show fallback UI with error message
  }

  // Method to log error details
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Error caught in ErrorBoundary:', error, info)

    // You could log the error to an error tracking service here (like Sentry)
  }

  render() {
    // If an error occurs, show the fallback UI with error details
    if (this.state.hasError) {
      return <ErrorFallback errorMessage={this.state.errorMessage} />
    }

    // Otherwise, render the children components as usual
    return this.props.children
  }
}

export default ErrorBoundary
